import {useSettings} from '@wix/tpa-settings/react'
import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa/cssVars'
import settingsParams from '../../../../settingsParams'
import {classes} from './page-title.st.css'

export const PageTitle = props => {
  const settings = useSettings()
  const pageTitleTag = settings.get(settingsParams.pageTitleTag) as string

  return <Text typography={TextTypography.largeTitle} {...props} className={classes.root} tagName={pageTitleTag} />
}
